import { render, staticRenderFns } from "./VCSwitch.vue?vue&type=template&id=3fa5b30e&scoped=true&"
import script from "./VCSwitch.vue?vue&type=script&lang=ts&"
export * from "./VCSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./VCSwitch.vue?vue&type=style&index=0&id=3fa5b30e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa5b30e",
  null
  
)

export default component.exports